import React from 'react';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';
import FlagNew from './flag-new';

const AllDepartments = ({ departments, dispatchMetrics }) => (
  <Menu>
    <Title>
      todos os <br /> departamentos
    </Title>
    {departments &&
      departments.map(department => (
        <Item key={department.id}>
          <Link
            to={department.link}
            onClick={() =>
              dispatchMetrics('event:track', {
                action: 'click',
                category: 'menu-header',
                label: department.title,
              })
            }
          >
            <ItemInner>
              {department.title}
              {department.flag === 'Novo' && <FlagNew />}
            </ItemInner>
          </Link>
        </Item>
      ))}
  </Menu>
);

export default AllDepartments;

const Menu = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 100%;
  padding: 1rem 0;
  margin: 0;
`;

const Item = styled.li`
  width: 250px;
`;

const ItemInner = styled.span`
  position: relative;
`;

const Link = styled(Nav)`
  display: block;
  padding: 5px 0 5px 32px;
  font-size: 14px;
  transition: color 0.3s;
  color: #666;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const Title = styled.li`
  padding: 0 0.875em 0.5em 1.2em;
  font-weight: 700;
  font-size: 20px;
  cursor: default;
  color: ${({ theme }) => theme.textColor};
`;
